module.exports = __webpack_public_path__ + "img/MaterialSymbolsLightFullscreenExit.cb8bb5eb.svg";